import React from 'react';
import { graphql } from 'gatsby';
import { CardNavigation as CardNavigationComponent } from '../../CardNavigation';

export const CardNavigation = ({ data, ...rest }) => <CardNavigationComponent {...data} {...rest} />;

export const CardNavigationQuery = graphql`
  fragment CardNavigation on KFH_UmbracoCardNavigationComponentType {
    cards {
      remoteTypeName
      ... on KFH_UmbracoCardNavigationCustomType {
        title
        text
        link {
          name
          url
          target
        }
        image {
          altText
          localFile {
            gatsbyImage(
              # outputPixelDensities: [1]
              width: 512
              height: 384
              layout: CONSTRAINED
              cropFocus: CENTER
              placeholder: NONE
              quality: 80
              backgroundColor: "#F5F5F5"
            )
          }
        }
      }
      ... on KFH_UmbracoCardNavigationPagePickerType {
        label
        page {
          pageName
          relativeUrl
          feed {
            shortTitle
            shortDescription
            featuredImage {
              altText
              localFile {
                gatsbyImage(
                  # outputPixelDensities: [1]
                  width: 512
                  height: 384
                  layout: CONSTRAINED
                  cropFocus: CENTER
                  placeholder: NONE
                  quality: 80
                  backgroundColor: "#F5F5F5"
                )
              }
            }
          }
        }
      }
    }
  }
`;
